import {
  frequentListApi,
  recentListApi,
  tagsListApi,
  submitSearchApi,
  searchAutoCompleteApi,
  searchAutoCompleteV1Api,
  searchAutoCompleteV2Api,
} from 'api/search';
import Employee from 'models/employee';

import {
  SEARCH_WIDGET_TYPES,
  SEARCH_TAG_TYPES,
  UNIVERSAL_SEARCH_RESULTS_LIMIT,
  UNIVERSAL_SEARCH_RESULTS_LIMIT_MOBILE,
  COHORTS_ID_MAPPING,
} from 'constants/ProjectConstants';

import {
  addActionItemsToTagResponse,
  parseSearchAutoCompleteRes,
  parseUniversalSearchAutoCompleteObjectives,
  parseUniversalSearchAutoCompleteRes,
  parseUniversalSearchAutoCompleteResV1,
} from './helpers/search';

export const fetchFrequentList = () => frequentListApi().then((res) => res.entity);

export const fetchRecentList = () => recentListApi().then((res) => res.entity);

// converting tags to search type
export const fetchTagsList = () => tagsListApi().then((res) => addActionItemsToTagResponse(res.entity));

export const submitSearch = (data = []) =>
  submitSearchApi(data).then((res) => {
    alert('successfully submited search');
    return { message: 'Successfully completed search', success: true };
  });

export const searchAutoComplete = ({ tagType, query, callback, widgetType, teamId, ...otherProps }) => {
  if (tagType === 'EMPLOYEE_NAME_AND_EMAIL') {
    searchAutoCompleteV2Api({
      moduleType: 'GOAL',
      searchText: query,
      offset: 0,
      limit: 5,
    })
      .then((res) => {
        const mappedData = res.entity.map((entry) => {
          const curEmployee = {
            uuid: entry.id,
            metadata: {
              displayName: entry.displayName,
              email: entry.email,
              designation: entry.designation,
              employeeFunction: entry.employeeFunction,
            },
            profile: {
              profilePhoto: entry.profilePhoto,
            },
            ownerType: entry.ownerType,
          };
          return {
            ...entry,
            employee: curEmployee,
            tagType: 'EMPLOYEE_NAME',
          };
        });
        const data = parseSearchAutoCompleteRes(mappedData || []);
        callback(data);
      })
      .catch((err) => console.error('An error occurred while searching', err));
  } else {
    searchAutoCompleteApi({ tagType, query, widgetType, teamId, ...otherProps })
      .then((res) => {
        const data = parseSearchAutoCompleteRes(res.entity || []);
        callback(data);
      })
      .catch((err) => console.error('An error occurred while searching', err));
  }
};

/**
 * @deprecated 8-04-2025
 */
export const universalSearchAutoComplete = ({ query, callback }) => {
  searchAutoCompleteApi({ query, widgetType: SEARCH_WIDGET_TYPES.search }).then((res) => {
    const data = parseUniversalSearchAutoCompleteRes(res.entity || []);
    return callback(data);
  });
};

export const universalSearchAutoCompleteV1 = (
  { text, tagsSet, callback, cohort },
  isMobileView = false,
  existingData
) => {
  // this is only for v0 of mobile site,
  if (isMobileView) {
    tagsSet = [
      {
        tagType: 'EMPLOYEE_NAME',
        limit: UNIVERSAL_SEARCH_RESULTS_LIMIT_MOBILE.employeeName,
      },
    ];
  }
  const tagTypeSet = tagsSet || [
    // {
    //   tagType: 'TEAM',
    //   limit: UNIVERSAL_SEARCH_RESULTS_LIMIT.team,
    // },
    {
      tagType: 'EMPLOYEE_NAME',
      limit: UNIVERSAL_SEARCH_RESULTS_LIMIT.employeeName,
    },
    // {
    //   tagType: 'ORGTAG',
    //   limit: UNIVERSAL_SEARCH_RESULTS_LIMIT.orgTag,
    // },
  ];
  searchAutoCompleteV1Api({
    text,
    widgetType: SEARCH_WIDGET_TYPES.search,
    tagTypeSet,
    cohort,
  }).then((res) => {
    const data = parseUniversalSearchAutoCompleteResV1(res.entity, existingData);
    return callback(data);
  });
};

// This was made to keep things simple, pass the tagSet and return promise, not callback
export const universalSearchAutoCompleteV2 = ({ text, tagsSet }) =>
  searchAutoCompleteV1Api({
    text,
    widgetType: SEARCH_WIDGET_TYPES.search,
    tagTypeSet: tagsSet,
  }).then((res) => parseUniversalSearchAutoCompleteResV1(res.entity));

export const departmentAutoComplete = ({ text, tagsSet }) =>
  searchAutoCompleteV1Api({
    text,
    widgetType: SEARCH_WIDGET_TYPES.search,
    tagTypeSet: tagsSet,
  }).then((res) =>
    // filtering out empty string "" and null values
    res.entity.DEPARTMENT.filter(({ displayName }) => displayName)
  );

export const universalSearchAutoCompleteObjectives = ({ text, tagsSet, timePeriod }) =>
  searchAutoCompleteV1Api({
    text,
    widgetType: SEARCH_WIDGET_TYPES.goal,
    tagTypeSet: tagsSet,
    timePeriod,
  }).then((res) => parseUniversalSearchAutoCompleteObjectives(res.entity));

export function employeeAutocompleteForMention({ query, teamId, widgetType }) {
  // const tagType = 'EMPLOYEE_NAME';
  const tagType = null;
  return searchAutoCompleteApi({
    tagType,
    query,
    widgetType,
    teamId,
  }).then((res) =>
    res.entity.map((entry) => {
      if (entry.tagType === SEARCH_TAG_TYPES.employee) {
        const employee = new Employee(null, entry.employee);
        employee.name = employee.fullName; // adding name key because draft js expects a name key to be there to use for displaying mention name
        employee.uuid = employee.id;
        return { employee, tagType: entry.tagType, name: employee.name };
      }
      return {
        group: entry.group,
        tagType: entry.tagType,
        name: entry.group.displayName,
      };
    })
  );
}

export function employeeAutocompleteForMentionWithLimit({ query, limit, module }) {
  return searchAutoCompleteV2Api({
    moduleType: module || 'FEEDBACK',
    searchText: query,
    offset: 0,
    limit,
  }).then((res) =>
    res.entity.map((entry) => {
      const metadata = {
        ...entry,
        displayName: entry.displayName,
        email: entry.email,
        designation: entry.designation,
        employeeFunction: entry.employeeFunction,
      };
      const employee = new Employee(null, {
        uuid: entry.id,
        metadata,
        profile: {
          profilePhoto: entry.profilePhoto,
        },
        ownerType: entry.ownerType,
      });
      employee.name = employee.fullName; // adding name key because draft js expects a name key to be there to use for displaying mention name
      employee.uuid = employee.id;

      return {
        ...entry,
        employee,
        tagType: entry.tagType,
        name: employee.name,
        metadata,
        companyId: entry.companyId,
        companyName: entry.companyName,
      };

      // This code is old and deprecated, keeping in commented form for now, should remove after 30 oct 2025
      // return {
      //   group: entry.group,
      //   tagType: entry.tagType,
      //   name: entry.group.displayName,
      // };
    })
  );
}

/**
 * @deprecated 8-04-2025
 */
export function employeeUniversalAutoSearch({ query, teamId, widgetType, limit, tagType }) {
  return searchAutoCompleteApi({
    tagType,
    query,
    widgetType,
    teamId,
    limit,
  }).then((res) =>
    res.entity.map((entry) => {
      if (entry.tagType === SEARCH_TAG_TYPES.employee) {
        const employee = new Employee(null, entry.employee);
        employee.name = employee.fullName; // adding name key because draft js expects a name key to be there to use for displaying mention name
        employee.uuid = employee.id;
        const { metadata } = entry.employee;

        return { employee, tagType: entry.tagType, name: employee.name, metadata };
      }
      return {
        group: entry.group,
        tagType: entry.tagType,
        name: entry.group.displayName,
      };
    })
  );
}

export function tagAutocomplete({ query, teamId, widgetType, employeeIds }) {
  const tagType = 'CORE_COMPETENCIES_TAG';
  return searchAutoCompleteApi({
    tagType,
    query,
    widgetType,
    teamId,
    employeeIds,
  }).then((res) => res.entity.map((object) => object.orgTag));
}

export function tagAutocompleteWithLimit({ query, teamId, widgetType, employeeIds, limit }) {
  const tagType = 'CORE_COMPETENCIES_TAG';
  return searchAutoCompleteApi({
    tagType,
    query,
    widgetType,
    teamId,
    employeeIds,
    limit,
  }).then((res) => res.entity.map((object) => object.orgTag));
}

export function driversAutocomplete({ query, teamId = null, widgetType }) {
  const tagType = 'ENGAGEMENT_DRIVER_TAG';
  return searchAutoCompleteApi({
    tagType,
    query,
    teamId,
    widgetType,
  }).then((res) => res.entity.map((object) => object.orgTag));
}

export const singleTagTypeAutocompleteV1 = ({ text, tagType, limit = 50, employeeIds }) => {
  const tagTypeSet = [
    {
      tagType,
      limit,
    },
  ];

  return searchAutoCompleteV1Api({
    text,
    widgetType: SEARCH_WIDGET_TYPES.search,
    tagTypeSet,
    employeeIds,
  }).then((res) => res.entity[tagType]);
};

/**
 * @deprecated 8-04-2025
 */
export const NominationPeerSearch = ({ text, tagsSet, callback, cohort, empId }, existingData) => {
  searchAutoCompleteV1Api({
    text,
    widgetType: SEARCH_WIDGET_TYPES.search,
    tagTypeSet: tagsSet,
    cohort,
    empId,
  })
    .then((res) => {
      const data = parseUniversalSearchAutoCompleteResV1(res.entity, existingData);
      return callback(data);
    })
    .catch((err) =>
      callback([
        {
          value: 'error',
          label: err.message || 'Oops! Something went wrong!',
          isDisabled: true,
        },
      ])
    );
};

export const NominationPeerSearchByEmail = ({ text, callback, limit, cohort }, existingData) => {
  searchAutoCompleteV2Api({
    moduleType: 'REVIEW',
    searchText: text,
    offset: 0,
    cohortId: COHORTS_ID_MAPPING[cohort] ?? '',
    limit,
  })
    .then((res) => {
      const data = res.entity.map((entry) => ({
        ...entry,
        uuid: entry.id,
        name: entry.displayName,

        tagType: entry.tagType,
        isDisabled: existingData && existingData.filter((r) => r.toString() === entry.id.toString()).length > 0,
      }));
      return callback(data);
    })
    .catch((err) =>
      callback([
        {
          value: 'error',
          label: err.message || 'Oops! Something went wrong!',
          isDisabled: true,
        },
      ])
    );
};
